import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Spinner from "../../../../common/Spinner/Spinner";
import ActionButton from "../../../../common/ActionButton/ActionButton";
import ConfirmDialog from "../../../../common/ConfirmDialog/ConfirmDialog";
import UnblockedEmailIcon from "../../../../Icon-SVG/UnblockedEmailIcon";
import ManualIcon from "../../../../Icon-SVG/ManualIcon";

import { RequestReleaseEmail } from "../../../../../store/actions/mailGatewayActions";

const ReleaseIcon = () => <UnblockedEmailIcon width={13} height={13} color="currentColor" />;

const BlockedEmailsRelease = (props) => {
  const action = props?.row?.original?.action || "-";
  const emailId = props.row.original?.email_id || "-";
  const host = props.row.original?.host || "-";
  const reason = props.row.original?.reason || "-";
  const sender = props.row.original?.sender || "";
  const subject = props.row.original?.subject || "";

  const [showConfirm, setShowConfirm] = useState(false);

  const loading = useSelector((state) => state.mailGateway.releaseEmailLoading);
  const releaseEmailId = useSelector((state) => state.mailGateway.releaseEmailId);

  const isLoading = loading && emailId === releaseEmailId;

  const dispatch = useDispatch();

  if (reason === "Processing") {
    return (
      <ActionButton icon={<ManualIcon width={13} height={13} color="currentColor" />} disabled>
        Manual
      </ActionButton>
    );
  }

  if (action === "Released") {
    return (
      <ActionButton icon={<ReleaseIcon />} disabled>
        Release
      </ActionButton>
    );
  }

  // The cell expands its row on click, so the click stops here.
  const requestReleaseHandler = (e) => {
    e.stopPropagation();
    if (emailId === "-" || host === "-") {
      return;
    }

    setShowConfirm(true);
  };

  const releaseHandler = () => {
    dispatch(RequestReleaseEmail({ emailId, host }));
  };

  if (action === "Block" || action === "Hold") {
    return (
      <>
        <ActionButton
          icon={isLoading ? <Spinner width={12} height={12} /> : <ReleaseIcon />}
          disabled={isLoading}
          onClick={requestReleaseHandler}>
          Release
        </ActionButton>
        {/* A blocked email was held back as a possible threat; releasing it
            delivers it to real mailboxes, so it is never done on one click. */}
        <ConfirmDialog
          show={showConfirm}
          setShow={setShowConfirm}
          onConfirm={releaseHandler}
          article="Release email?"
          textOK="Release"
          textCancel="Cancel">
          <span className="confirm-dialog__subject">
            {sender ? (
              <span className="confirm-dialog__field">
                <span className="confirm-dialog__label">From:</span>
                {sender}
              </span>
            ) : null}
            <span className="confirm-dialog__field">
              <span className="confirm-dialog__label">Subject:</span>
              {subject || "(no subject)"}
            </span>
          </span>
          <span className="confirm-dialog__note">
            This email was blocked. Releasing it delivers it to its recipients.
          </span>
        </ConfirmDialog>
      </>
    );
  }
};

export default BlockedEmailsRelease;
